import { render, staticRenderFns } from "./ModalSuporteSalaRobotica.vue?vue&type=template&id=724d47df&scoped=true"
import script from "./ModalSuporteSalaRobotica.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteSalaRobotica.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteSalaRobotica.vue?vue&type=style&index=0&id=724d47df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d47df",
  null
  
)

export default component.exports